import script from "./CreateAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAccountView.vue?vue&type=script&setup=true&lang=js"

import "./CreateAccountView.vue?vue&type=style&index=0&id=ea8d9a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea8d9a06"]])

export default __exports__